import { createSelector } from 'reselect';

import { buildUnitToBulkCommandMapping, buildUnitToSiteMapping } from '@sophocles/entities/unitCommandMappingSelectors';
import { getAuthUserSelector } from '@sophocles/features/auth/authSelectors';

export const pendingUnitCommandSelector = state => state.entities.pendingUnitCommands.get('entities');

export const getPendingUnitToSiteMapping = createSelector(
  pendingUnitCommandSelector,
  getAuthUserSelector,
  buildUnitToSiteMapping,
);

export const getPendingUnitToBulkCommandMapping = createSelector(
  pendingUnitCommandSelector,
  getAuthUserSelector,
  buildUnitToBulkCommandMapping,
);
